import { ParsedDate, parseIsoDate } from '@api/Trinium/types';

export interface BrokerRaw {
	id: string;
	name: string;
	liabInsAmt?: number;
	liabInsExpDate: string;
	cargoInsAmt?: number;
	cargoInsExpDate: string;
}

type ExcludedRawBrokerypes = 'liabInsExpDate' | 'cargoInsExpDate';

export type BrokerCarrier = Omit<BrokerRaw, ExcludedRawBrokerypes> & {
	liabInsExpirationDate: ParsedDate | null;
	cargoInsExpriationDate: ParsedDate | null;
};

export function transformBrokerCarrierResponse({ liabInsExpDate, cargoInsExpDate, ...fields }: BrokerRaw) {
	return {
		...fields,
		liabInsExpirationDate: parseIsoDate(liabInsExpDate),
		cargoInsExpriationDate: parseIsoDate(cargoInsExpDate)
	} as BrokerCarrier;
}

export function transformBrokerCarriersResponse(response: BrokerRaw[]) {
	return response.map((broker) => transformBrokerCarrierResponse(broker));
}
